import FilterIcon from "@redotech/redo-icons/filter-lines_filled.svg";
import type { RuleConditionsStep } from "@redotech/redo-model/advanced-flow/rules/schemas";
import { RedoFeaturedIcon } from "@redotech/redo-web/arbiter-components/featured-icon/redo-featured-icon";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { Handle, Position } from "@xyflow/react";
import { memo } from "react";
import type { PartialFlowStep, PartialWithRequiredType } from "../../steps";
import { countConditionsRecursive } from "../../steps/rules/rule-conditions-step";
import { BaseNode } from "../base-node";
import * as NodeCSS from "../node.module.css";

export interface RuleConditionsNodeData {
  step: PartialWithRequiredType<RuleConditionsStep>;
  deleteElements: (id: string) => void;
  updateStep: (id: string, updatedStep: PartialFlowStep) => void;
  readonly: boolean;
  hovered?: boolean;
}

export const RuleConditionsNode = memo(function RuleConditionsNode({
  id,
  data,
  selected,
}: {
  id: string;
  data: RuleConditionsNodeData;
  selected?: boolean;
}) {
  const conditionsCount = data.step.conditionGroups
    ? countConditionsRecursive(data.step.conditionGroups)
    : 0;
  const summary =
    conditionsCount === 0
      ? "No conditions"
      : `${conditionsCount} condition${conditionsCount > 1 ? "s" : ""}`;

  return (
    <>
      <Handle position={Position.Top} type="target" />
      <BaseNode
        hovered={data.hovered}
        icon={
          <RedoFeaturedIcon
            color="gray"
            Icon={FilterIcon}
            shape="circle"
            size="md"
          />
        }
        onDelete={() => data.deleteElements(id)}
        selected={selected}
        step={data.step}
        title="Rule Conditions"
      >
        <Flex dir="column" gap="xs" w="full">
          <Text
            fontSize="xs"
            style={{ color: "var(--redo-colors-text-tertiary)" }}
          >
            {summary}
          </Text>
        </Flex>
        <Handle
          className={NodeCSS.edgeHandle}
          id="a"
          position={Position.Bottom}
          type="source"
        />
        <Handle
          className={NodeCSS.edgeHandle}
          id="b"
          position={Position.Bottom}
          type="source"
        />
      </BaseNode>
    </>
  );
});
